import Highcharts from "Static/js/highstock";
import PropTypes from "prop-types";
import React from "react";
import { utcToLocal } from "util/time";
import { Box } from "view/layout/box";

class ConnectionChart extends React.PureComponent {
  static get propTypes() {
    return {
      data: PropTypes.array.isRequired,
      small: PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      small: false,
    };
  }

  constructor(props) {
    super(props);

    this.chartElem = null;
    this.highchart = null;

    this.destroy = this.destroy.bind(this);
  }

  componentDidUpdate() {
    this._renderChart(this.props);
  }

  componentDidMount() {
    this._renderChart(this.props);
  }

  componentWillUnmount() {
    this.destroy();
  }

  destroy() {
    if (this.highchart) {
      this.highchart.destroy();
    }
  }

  _getData(data) {
    const { small } = this.props;

    return data.map(([ts, status]) => {
      let y;

      if (small) {
        y = 1;
      } else {
        y = status ? 1 : -1;
      }

      return {
        y,
        color: status ? "#008d4c" : "#f4543c",
        name: status ? "Online" : "Offline",
        x: ts,
      };
    });
  }

  _renderChart(props) {
    const { data, small } = props;
    const noData = data.length === 0;
    if (noData) {
      return;
    }

    const { chartElem } = this;
    const opts = {
      chart: {
        renderTo: chartElem,
        type: "column",
        ...(small
          ? {
              height: 60,
              spacing: [-15, 0, -15, 0],
            }
          : {}),
      },
      xAxis: {
        type: "datetime",
        labels: {
          enabled: !small,
        },
        title: {
          enabled: false,
        },
        ...(small ? { tickLength: 0 } : {}),
        gridLineWidth: 0,
      },
      title: {
        text: "",
        style: {
          display: "none",
        },
      },
      tooltip: {
        formatter: function () {
          // Do not make this an arrow function.
          const eventTime = utcToLocal(this.x);

          return `${this.point.name}<br>${eventTime}`;
        },
        shared: false,
      },
      plotOptions: {
        series: {
          connectNulls: false,
          // Allow per-minute charts
          turboThreshold: 48 * 60,
        },
      },
      yAxis: {
        title: null,
        labels: {
          enabled: false,
        },
        type: "category",
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        startOnTick: false,
        showFirstLabel: true,
        showLastLabel: true,
      },
      series: [
        {
          data: this._getData(data),
          showInLegend: false,
          name: null,
        },
      ],
      credits: {
        enabled: false,
      },
    };

    this.destroy();

    this.highchart = new Highcharts.Chart(opts);
  }

  render() {
    const { data, small } = this.props;
    const noData = data.length === 0;

    const chart = (
      <div
        className="chart"
        ref={(elem) => {
          this.chartElem = elem;
        }}
      >
        {noData && <div>No data for chart.</div>}
      </div>
    );

    if (small) {
      return chart;
    }

    return (
      <Box title="Connection Status" type="default">
        {chart}
      </Box>
    );
  }
}

export { ConnectionChart };
